export default __webpack_public_path__ + "static/media/buttonActionInActive.fd4e0b03.svg";